import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { IConfirmModalContent, withConfirmationService } from '@aston/foundation';
import { Component, inject, input } from '@angular/core';
import { signalStore } from '@ngrx/signals';

const Store = signalStore(withConfirmationService())

@Component({
	selector: 'ai-chat-help-bar',
	template: `
		<div class="buttons-bar p-2 d-flex justify-content-between">
			<span class="inline-block mr-auto ml-4" translate="Support.Contact"></span>
			<a class="mx-2" target="_blank" href="mailto:{{'Support.Email'|translate}}" [ngbTooltip]="'Support.EmailText'|translate" placement="bottom" container="body" [openDelay]="500"><i class="far fa-envelope"></i></a>
			<a class="mx-2" target="_blank" href="tel:{{'Support.Phone'|translate}}" [ngbTooltip]="'Support.PhoneText'|translate" placement="bottom" container="body" [openDelay]="500" (click)="openPhoneModal($event)"><i class="far fa-phone"></i></a>
			<a class="mx-2" target="_blank" [href]="'Support.TicketUrl'|translate" [ngbTooltip]="'Support.TicketUrlText'|translate" placement="bottom" container="body" [openDelay]="500"><i class="far fa-comments"></i></a>
			<a class="mx-2" target="_blank" [href]="'Support.MeetUrl'|translate" [ngbTooltip]="'Support.MeetUrlText'|translate" container="body" [openDelay]="500"><i class="far fa-calendar"></i></a>
		</div>
		@if (beta()) {
			<div class="beta-banner" translate="App.AIChat.BetaVersion"></div>
		}
		@if (insight()) {
			<div class="beta-banner" translate="App.AIChat.Insight"></div>
		}
	`,
	styles: `
		.buttons-bar {
			z-index: 10;
			background: var(--body-bg);
			position: relative;
		}
		.beta-banner {
			position: absolute;
			width: 110px;
			height: 25px;
			background: #EE8E4A;
			top: 55px;
			right: -23px;
			text-align: center;
			font-size: 13px;
			font-family: sans-serif;
			text-transform: uppercase;
			font-weight: bold;
			color: #fff;
			line-height: 27px;
			transform: rotate(45deg);
			z-index: 9;
		}
	`,
	imports: [
		TranslateModule,
		NgbTooltipModule
	],
	providers: [
		Store,
	]
})
export class AIHelpBarComponent {
	i18n = inject(TranslateService)
	store = inject(Store)
	beta = input(true)
	insight = input(true)

	openPhoneModal(e: Event) {
		e.preventDefault()
		const number = this.i18n.instant('Support.Phone')
		const phone = `<a href="tel:${number}" target="_blank">${number.replace(/([^^])(\d\d)/g, "$1$2 ").trim()}</a>`
		this.store.confirm({
			textsKey: 'Support.Modals.Phone.',
			questionParams: { phone },
			hideConfirmBtn: true,
			hideCancelBtn: true,
		} as unknown as IConfirmModalContent)
	}
}
